export default __webpack_public_path__ + "static/media/1.b71394d9.png";